import React from 'react';

import AuthButton from './AuthButton';
import queryString from './util/queryString';

import 'css/components/_ForceAdminOAuth.scss';

interface ForceAdminOAuthProps {
  companyID: string;
  forcedMemberAuthMechanism?: string;
  removeBranding?: boolean;
  onFailure?: (error: any) => void;
  onSuccess?: (data: any) => void;
}

const getCompanySpecificSSOText = (companyID: string, removeBranding?: boolean): string => {
  const intuitCompanyIDs = ['66edb5c1ed00040716620a67', '6757217f51699e97fb54f041'];

  if (intuitCompanyIDs.includes(companyID)) {
    return 'Log in with Intuit SSO';
  }

  return removeBranding ? 'Log in with SSO' : 'Log in to Canny with SSO';
};

const ForceAdminOAuth: React.FC<ForceAdminOAuthProps> = ({
  companyID,
  forcedMemberAuthMechanism,
  removeBranding,
  onFailure,
  onSuccess,
}) => {
  let params;
  const loginCopy = {
    adminLinkText: getCompanySpecificSSOText(companyID, removeBranding),
  };

  switch (forcedMemberAuthMechanism) {
    case 'oidc':
      params = {
        companyID,
        validateConfig: 'false',
      };
      return (
        <a
          href={`/api/oidc/initiate${queryString.stringify(params)}`}
          className="accountModalAdminLink">
          {loginCopy.adminLinkText}
        </a>
      );
    case 'azure':
      return (
        <div className="alternativeSignIn">
          <AuthButton
            authType="azure"
            onFailure={onFailure}
            onSuccess={onSuccess}
            value="Log in with Microsoft Entra ID"
          />
        </div>
      );
    default:
      return null;
  }
};

export default ForceAdminOAuth;
